<template>
  <mdb-select
    :multiple="multipleSelected"
    v-if="loadReady"
    v-on:getValue="getSelectValue"
    :options="labelOptions"
    :visibleOptions="6"
    icon="list"
    :label="$t('category')"
    :placeholder="$t('choose_category')"
  />
</template>

<script>
import { mdbSelect } from "mdbvue";
export default {
  name: "Categories",
  components: {
    mdbSelect,
  },
  props: {
    multipleSelected: Boolean,
    categoryId: Number,
    categoriesInAdv: Array,
  },
  data() {
    return {
      loadReady: false,
      categories: [],
      labelOptions: [],
      categoriespath: "/1.0/front/categories",
    };
  },
  methods: {
    checkCategoryId() {
      this.labelOptions = [];
      var defaultSelection = undefined;
      if (
        this.categoriesInAdv !== null &&
        this.categoriesInAdv !== undefined &&
        this.categoriesInAdv.length > 0
      ) {
        defaultSelection = this.categoriesInAdv[0].id;
      }
      console.log(defaultSelection);
      this.categories.forEach((category) => {
        this.labelOptions.push({
          text: category.display,
          value: category.id,
          selected: this.getSelectedStatus(category, defaultSelection),
        });
      });
    },
    getSelectedStatus(category, defaultSelection) {
      if (this.categoriesInAdv !== null && this.categoriesInAdv !== undefined) {
        return this.categoriesInAdv.some((obj) => obj.id === category.id);
      } else {
        return defaultSelection === category.id ? true : false;
      }
    },
    getSelectValue(value, text) {
      this.$emit("categories", value, text);
    },
  },
  watch: {
    categoryId: function (newVal, oldVal) {
      if (newVal !== 0 && this.categories !== null) {
        this.checkCategoryId();
      }
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    },
    categoriesInAdv: function (newVal, oldVal) {
      if (newVal !== undefined && this.categories !== null) {
        this.checkCategoryId();
      }
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    },
  },
  mounted() {
    this.$http
      .get(this.categoriespath)
      .then((response) => {
        if (response.status == 200) {
          this.categories = response.data.categories;
          this.checkCategoryId();
          this.loadReady = true;
        } else if (response.status == 401) {
          this.$root.$emit("session_failed");
        }
      })
      .catch((error) => {
        window.__logAxiosErrorIfDebug(error, {
          context: "Categories.vue - mounted",
        });
        this.$root.$emit("session_failed");
        return error;
      });
  },
};
</script>

<style></style>
